
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puppies-for-sale/[breed-slug]/[state]",
      function () {
        return require("private-next-pages/puppies-for-sale/[breed-slug]/[state]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puppies-for-sale/[breed-slug]/[state]"])
      });
    }
  